<template>
 <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
                 <v-toolbar
          color="red lighten-3"
          dark
        >

          <v-toolbar-title   class="headline">Skapa ny måendekontroll</v-toolbar-title>
        </v-toolbar>
            <v-card-text>
              <v-container>
                <v-flex>
                  <v-flex>
                    <v-text-field
                      label="Elevnamn"
                      hint="Elevens namn."
                      required
                      v-model="NewFeeling.name"
                    ></v-text-field>
                  </v-flex>    

                                   <v-flex >
              <v-select
                v-model="NewFeeling.questions"
                :items="questions"
                item-text="Q"
                item-value="short"
                attach
                multiple
                chips
                label="Tillägsfrågor"
                hint="Vill du ha ytterliggare frågor? De kan ge ökad insikt men också äventyra för att elevens svarsfrekvens."
                persistent-hint
              ></v-select>
            </v-flex>                            
                   
                  <v-flex>
    <v-radio-group label="Är måendekontrollen löpande eller tidsbegränsad."
     v-model="Time"
    >
      <v-radio
        label="Löpande"
        value="going"
      ></v-radio>
      <v-radio
        label="Tidsbegränsad"
        value="timed"
      ></v-radio>
    </v-radio-group>
       </v-flex> 
    <v-flex v-if="Time=='timed'">
                        <p>När går den tidsbestämda måendekontrollen ut?</p>
    <v-date-picker v-model="NewFeeling.expireDate"></v-date-picker>
                   </v-flex>
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="red darken-1" @click="show = false">
                Stäng
              </v-btn>
              <v-btn
                color="green lighten-1"
                text
                dark
                @click="change()"
                v-if="Oldclass!=null"
              >
                Uppdatera protokoll
              </v-btn>
                            <v-btn
                color="green lighten-1"
                text
                dark
                @click="change()"
                v-else
              >
                Skapa protokoll
              </v-btn>
            </v-card-actions>
          </v-card>
 </v-dialog>
</template>
<script>
import { mapActions,mapGetters } from "vuex";
export default {
    name:"NewFeeling",

  computed: {
    show: {
      get () {
          if (this.Oldclass!=null) {
        this.NewFeeling=this.Oldclass;
          this.update=true;
          }
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

    created(){
      if (this.Oldclass!=null) {
        this.NewFeeling=this.Oldclass;
      }
    },
    props:{
        membernameandId: Array,
        Oldclass: Object,
        schoolId: String,
        id:String,
        value: Boolean
    },
data() {
    return {
         update:false ,
        Time: "going",
        questions:[{Q:"Har du tagit dina mediciner?", short:"med", ans:"y"},{Q:"Har du varit eller ska du till skolan idag?", short:"sch", ans:"y"},{Q:"Har du ätit mat i skolan idag?", short:"food", ans:"y"},
        {Q:"Hur många timmar har du sovit i natt?", short:"sleep", ans:"ten"}],
            NewFeeling: {
        schoolId: this.schoolId,
      },
      locfun: null,
    };
  },

  methods: {
    ...mapActions("feeling", ["createFeeling","saveFeeling"]),
    ...mapActions(['showSuccessSnackbar']),
  change(){
    if ( typeof(this.NewFeeling.createDate)=="object") {
    this.NewFeeling.createDate=this.NewFeeling.createDate.getTime();
    }
    if (this.NewFeeling.hasOwnProperty('expireDate')) 
    if ( typeof(this.NewFeeling.expireDate)=="object") {
    this.NewFeeling.expireDate=this.NewFeeling.expireDate.getTime();
    }
    // if (this.NewFeeling.accessType.length!=1) {
    //   if (this.NewFeeling.accessType.length==3) {
    //     this.NewFeeling.accessType=="all";
    //   }
    //   else if
    // }

    if (this.update==false) {
      this.NewFeeling.creator= this.id;
      this.NewFeeling.schoolId= this.schoolId;

    this.createFeeling(this.NewFeeling);
    this.showSuccessSnackbar('Måendekoll för ' + this.NewFeeling.name+ ' är skapad! En kod har skapats som du kan dela med eleven för att logga sitt mående.');
    }
    else
    {
    this.saveAP(this.NewFeeling);
    this.showSuccessSnackbar('Måendekoll för ' +  this.NewFeeling.name+ ' är updaterad!');
    } 
     if (this.Oldclass==null) {
       this.NewFeeling= {
      }
     }
     
     this.show = false;
  }
    
  }
}
</script>
<style >

</style>